import React, { useState } from 'react';
import '../style/common.css';
import { useTranslation } from 'react-i18next';

const TogglerSwitch = ({onDivActivate}) => {
  const [activeState, setActiveState] = useState({
    chart: true,
    table: false,
  });
  const { t } = useTranslation('common');

  const activateDiv = (divName) => {
    setActiveState((prevState) => ({
      ...prevState,
      chart: divName === 'chart',
      table: divName === 'table',
    }));
    onDivActivate(divName);
  };

  return (
    <div className='toggle-holder'>
      <div
        onClick={() => activateDiv('chart')}
        className={`xxxs-normal toggle-div ${activeState.chart ? 'active' : ''}`}
        style={{ borderTopLeftRadius: 4, borderBottomLeftRadius: 4}}
      >
        {t("Chart")}
      </div>

      <div
        onClick={() => activateDiv('table')}
        className={`xxxs-normal toggle-div ${activeState.table ? 'active' : ''}`}
        style={{ borderLeft: '1px solid #123261', borderTopRightRadius: 4, borderBottomRightRadius: 4}}
      >
        {t("Table")}
      </div>
    </div>
  );
};

export default TogglerSwitch;
